import React from 'react';
import SignupContainer from 'views/SignupContainer';
import LoginView from 'shared/components/Forms/LoginForm';

const Login = () => {
  return (
    <SignupContainer>
      <LoginView />
    </SignupContainer>
  );
};

export default Login;
